export const optionsSelectPeriod = [
    {
        text: "12/08/2025 - 12/12/2025",
        value: "12/08/2025 - 12/12/2025",
    },
    {
        text: "12/08/2024 - 12/12/2024",
        value: "12/08/2024 - 12/12/2024",
    },
];

export const summaryData = {
    current: {
        plan: 0,
        approved: 0,
        percentage: 0,
        completed: 0,
    },
    previous: {
        plan: 0,
        approved: 0,
        percentage: 0,
        completed: 0,
    },
};

export const emp = {
    nik: '',
    name: '',
    division: '',
    position: '',
}

export const tableFields = {
    structured: [
        { key: 'select', label: '' },
        { key: 'index', label: '#' },
        { key: 'training.title', label: 'Course Title' },
        { key: 'competency.name', label: 'Competency' },
        { key: 'training.platform', label: 'Platform' },
        { key: 'training.provider.name', label: 'Provider' },
        { key: 'training.price', label: 'Cost' },
        { key: 'status', label: 'Status' },
    ],

    social: [
        { key: 'select', label: '' },
        { key: 'index', label: '#' },
        { key: 'coaching.title', label: 'Coaching Title' },
        { key: 'competency.name', label: 'Competency' },
        { key: 'competency.difference', label: 'Gap' },
        { key: 'coaching.methodology', label: 'Methodology' },
        { key: 'coaching.coach_name', label: 'Coach' },
        { key: 'status', label: 'Status' },
    ],

    experiential: [
        { key: 'select', label: '' },
        { key: 'index', label: '#' },
        { key: 'project.name', label: 'Project Name' },
        { key: 'project.related_competencies[0].competency_name', label: 'Competency' },
        { key: 'project.start_date', label: 'Start Date' },
        { key: 'project.end_date', label: 'End Date' },
        { key: 'status', label: 'Status' },
        { key: 'Action', label: 'Action' },
    ],
};

export const getBadgeStatus = (status) => {
    switch (status) {
        case 'approval_hr':
        case 'approval_manager':
        case 'approval_hse':
        case 'feedback':
        case 'open':
            return 'secondary';
        case 'rejected':
            return 'danger';
        case 'approved':
            return 'success';
        default:
            return 'light';
    }
}

export const handleApproveSwal = {
    title: 'Approve TNA?',
    icon: "warning",
    // text: 'Masukkan catatan (opsional):',
    // input: 'textarea',
    // inputPlaceholder: 'Tulis catatan di sini...',
    showCancelButton: true,
    confirmButtonText: 'Approve',
    cancelButtonText: 'Batal',
    inputAttributes: {
        'aria-label': 'Catatan'
    }
}

export const handleApproveWithReviseSwal = {
    title: 'Revise TNA ?',
    text: 'Masukkan catatan:',
    input: 'textarea',
    inputPlaceholder: 'Tulis catatan di sini...',
    showCancelButton: true,
    confirmButtonText: 'Revise',
    cancelButtonText: 'Batal',
    inputAttributes: {
        'aria-label': 'Catatan'
    }
}

export const handleRejectSwal = {
    title: 'Reject TNA ?',
    text: 'Masukkan catatan:',
    input: 'textarea',
    inputPlaceholder: 'Tulis catatan di sini...',
    showCancelButton: true,
    confirmButtonText: 'Reject',
    cancelButtonText: 'Batal',
    inputAttributes: {
        'aria-label': 'Catatan'
    }
}

export const msgActionSwal = {
    success: {
        title: 'Berhasil!',
        text: 'TNA berhasil disetujui.',
        icon: 'success',
        confirmButtonText: 'OK'
    },
    error: {
        title: 'Error!',
        text: 'TNA gagal disetujui, coba lagi.',
        icon: 'error',
        confirmButtonText: 'OK'
    },
    successReject: {
        title: 'Berhasil!',
        text: 'TNA berhasil ditolak.',
        icon: 'success',
        confirmButtonText: 'OK'
    },
    errorReject: {
        title: 'Error!',
        text: 'TNA gagal ditolak, coba lagi.',
        icon: 'error',
        confirmButtonText: 'OK'
    }
}